import React from "reactn"
import { Box, Grid, GridItem } from "@chakra-ui/react"
import Carousel from "./carousel"
import ProductInfo from "./productInfo"
import { IngmarsonCard } from "../card"
import SizeGuide from "./sizeGuide"
import { graphql } from "gatsby"

export default function ProductPage({ globalState, isDesign = false, isGarment = true, searchObjectID, collection, itemLocation, searchQueryID,
    product, productMetafields, shipping, productInformation }) {
    const {
        title,
        media
    } = product
    console.log("IS GARMENT", isGarment)
    const leftSide = isDesign ? 5 : 7
    const rightSide = isDesign ? 7 : 5
    return (
        <Box id="productPage" >
            <Box margin={10}>
                <Grid templateRows="repeat(1, 1fr)" templateColumns="repeat(12, 1fr)" gap={4} >
                    <GridItem colSpan={[12, 12, 12, leftSide]} rowSpan={1}>
                        <Carousel images={media} title={title} isDesign={isDesign}/>
                    </GridItem>
                    <GridItem colSpan={[12, 12, 12, rightSide]} rowSpan={1}>
                        <ProductInfo isGarment={isGarment} isDesign={isDesign} collection={collection} itemLocation={itemLocation} searchHit={searchObjectID} searchObjectID={searchObjectID} searchQueryID={searchQueryID} product={product} productMetafields={productMetafields} shipping={shipping} productInformation={productInformation} globalState={globalState} />
                    </GridItem>
                </Grid>
            </Box>
            <IngmarsonCard >
                <SizeGuide size={productMetafields.size} extraSizeInfo={productMetafields.extra_size_info} isDesign={isDesign}/>
            </IngmarsonCard>            
        </Box>
    )
}

export const query = graphql `
  fragment ProductData on ShopifyProduct {
    internal {
        type
      }
      handle
      shopifyId
      altcolors
      fields {
        sku
        gender
        suggestedGender
        nowPlusOneYear
        slugCategory
        lastReviewed
        releaseDate
        slug
        availableForSale
        draft
        archived
        is_alumni
        is_deleted
      }
      metafields {
        fields {
          care_info
          sustainability_score
          meta_title
          meta_description
          color
          price
          sale_price
          on_sale
          care_info
          extra_care_info
          extra_size_info
          gender
          size
          social_image
          social_images
          own_garment
          color_name 
          is_multicolor
        }
      }
      title
      description
      descriptionHtml
      productType
      tags      
      storefrontId
      media {
        ... on ShopifyVideo {
          internal {
            type
          }
          sources {
            url
          }
          preview {
            image {
              altText
              gatsbyImageData
            }
          }
        }
        ... on ShopifyMediaImage {
          image {
            altText
            gatsbyImageData(
              width: 500
            )
          }
          internal {
            type
          }
        }
      }
      variants {
        availableForSale
        storefrontId
        title
        price
        sku
        selectedOptions {
          name
          value
        }
      }
      options {
        name
        values
      }
  }
`

